import { render, staticRenderFns } from "./ModalProyectos.vue?vue&type=template&id=7dc2b768&scoped=true"
import script from "./ModalProyectos.vue?vue&type=script&lang=js"
export * from "./ModalProyectos.vue?vue&type=script&lang=js"
import style0 from "./ModalProyectos.vue?vue&type=style&index=0&id=7dc2b768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc2b768",
  null
  
)

export default component.exports